module.exports = __webpack_public_path__ + "static/img/company.4d4a50a.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/company.png
// module id = oyGz
// module chunks = 1